import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routingLocationChange } from '../store/routingCompatSlice';
import query from '../helpers/query';

export default function RouterSync() {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const queryParams = query.parse(location.search);
        
        dispatch(
            routingLocationChange({
                pathname: location.pathname,
                search: location.search,
                hash: location.hash,
                key: location.key,
                state: location.state,
                query: queryParams,
            })
        );
    }, [dispatch, location]);

    return null;
}
